import * as PIXI from 'pixi.js'
import { CustomPIXIComponent } from 'react-pixi-fiber'
import { McSpine } from '../utils'

require('pixi-spine')

/**
 * React-pixi implementation of the pixi.js Spine functionality.
 */
export default CustomPIXIComponent({
  customDisplayObject(props) {
    if (!props.spine) {
      return new PIXI.DisplayObject()
    }

    const spine = new McSpine(props.spine.spineData)
    spine.defaultSpeed = !isNaN(props.speed) ? props.speed : 1
    spine.state.timeScale = spine.defaultSpeed

    spine.state.addListener({
      start: () => props.onStart && props.onStart(),
      complete: () => {
        if (spine.animationDone) {
          /**
           * pixi_spine introduces a race condition between the destroy function
           * and the autoUpdate functionality they have, as they hijack the
           * updateTransform hook from regular pixi.js to update the spine without
           * regarding that it might not complete before destroy is called.
           * To mitigate this race condition, we have to delay the animationDone
           * event by one tick, to ensure they don't attempt to run at the same time
           */
          setTimeout(() => spine.animationDone())
        }
      }
    })

    if (props.onCreate) {
      props.onCreate(spine)
    }

    return spine
  },

  customApplyProps(displayObject, oldProps, newProps) {
    if (newProps.speed !== oldProps.speed) {
      displayObject.defaultSpeed = !isNaN(newProps.speed) ? newProps.speed : 1
      displayObject.state.timeScale = newProps.paused ? 0 : displayObject.defaultSpeed
    }

    if (newProps.animation && ((newProps.animation !== oldProps.animation) ||
    (newProps.loop !== oldProps.loop))) {
      const { animation } = newProps

      if (displayObject.state.hasAnimation(animation)) {
        if (displayObject.defaultMix && oldProps.animation) {
          displayObject.stateData.setMix(oldProps.animation, animation, displayObject.defaultMix)
        }

        const loop = newProps.loop !== undefined ? !!newProps.loop : true

        displayObject.state.setAnimation(0, animation, loop)
        displayObject.state.timeScale = displayObject.defaultSpeed
      }
    }

    if (newProps.pause !== oldProps.pause) {
      displayObject.state.timeScale = newProps.pause ? 0 : displayObject.defaultSpeed
    }

    if (newProps.animationDone !== undefined && newProps.animationDone !== oldProps.animationDone) {
      displayObject.animationDone = newProps.animationDone
    }

    if (newProps.x !== undefined && newProps.x !== oldProps.x) {
      displayObject.position.x = newProps.x
    }

    if (newProps.y !== undefined && newProps.y !== oldProps.y) {
      displayObject.position.y = newProps.y
    }

    if (newProps.defaultMix !== undefined && newProps.defaultMix !== oldProps.defaultMix) {
      displayObject.defaultMix = newProps.defaultMix
    }

    if (newProps.cacheAsBitmap !== oldProps.cacheAsBitmap) {
      displayObject.cacheAsBitmap = !!newProps.cacheAsBitmap
    }

    if (newProps.scale !== undefined && newProps.scale !== oldProps.scale) {

      if (!isNaN(newProps.scale)) {
        displayObject.scale = { x: newProps.scale, y: newProps.scale }
      } else {
        displayObject.scale = newProps.scale || { x: 1, y: 1 }
      }
    }
  },

  customWillDetach(displayObject) {
    displayObject.state.clearListeners()
  },
}, 'SpineRenderer')
